import sp from "../../../assets/images/Footer/sp.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaAngleRight } from "react-icons/fa";
import { FaAngleLeft } from "react-icons/fa";

import clock_3 from "../../../assets/images/NewEvent/clock_3.svg";
import user_status from "../../../assets/images/NewEvent/user_status.svg";
import list from "../../../assets/images/NewEvent/list.svg";
import { Divider } from "@mui/material";
import { Link } from "react-router-dom";

function getCategoryName(categories, ids) {
  const arrIds = ids
    ? ids
        .split(",")
        .map((num) => Number(num))
        .filter((n) => n > 0)
    : [];
  const cat = categories.find(
    (item) => item.id == (arrIds.length > 0 ? arrIds[0] : 0)
  );
  return cat?.name ?? "";
}

function extractFirstImageAndText(htmlContent) {
  // Tìm thẻ <img> đầu tiên
  const imgRegex = /<img[^>]*src="([^"]*)"[^>]*>/;
  const match = imgRegex.exec(htmlContent);

  let firstImage = null;
  if (match) {
    firstImage = match[1]; // Lấy src của thẻ <img> đầu tiên
  }

  // Xóa thẻ <img> đầu tiên khỏi nội dung HTML
  const textWithoutFirstImage = htmlContent.replace(imgRegex, "");

  return { text: textWithoutFirstImage, firstImage };
}

function renderPCNewsItem(newItem, categories) {
  let { text, firstImage } = extractFirstImageAndText(newItem.shortContent);
  return (
    <div className=" w-full gap-3 border rounded-[8px] border-solid border-gray-200 shadow-custom-light  ">
      <div className="w-full flex flex-col gap-3">
        <div>
          <Link to={`/tintuc-chitiet/${newItem.slug}`}>
            <img
              src={firstImage}
              className="w-full h-auto object-cover rounded-[8px]"
            />
          </Link>
        </div>
        <div className="w-full px-[24px] py-[16px] flex flex-col gap-3">
          <div>
            <Link to={`/tintuc-chitiet/${newItem.slug}`}>
              <p className="text-[16px] font-semibold text-[#1F1F1F] hover:text-[#053CC8] cursor-pointer">
                {newItem.title}
              </p>
            </Link>
          </div>
          <div className="flex items-center justify-between md:flex-col lg:flex-row md:items-center md:gap-1 w-full">
            <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
              <div className="w-[16px] h-[16px]">
                <img src={user_status} alt="u1" />
              </div>
              <p>{newItem.author}</p>
            </div>
            <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
              <div className="w-[16px] h-[16px]">
                <img src={clock_3} alt="cl" />
              </div>
              <p>{new Date(newItem.publishDate).toLocaleDateString()}</p>
            </div>
          </div>
          <div>
            <Divider />
          </div>

          <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
            <div>
              <img src={list} alt="li" />
            </div>
            <p>{getCategoryName(categories, newItem.categories)}</p>
          </div>

          <div>
            <p className="text-[16px] text-[#333333] font-normal">
              <div
                dangerouslySetInnerHTML={{ __html: text }}
                className="h-32 overflow-auto overflow-x-hidden"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function renderMobileNewsItem(newItem, categories) {
  let { text, firstImage } = extractFirstImageAndText(newItem.shortContent);
  return (
    <div className=" w-full gap-3  rounded-[8px] border border-solid border-gray-300 shadow-custom-light ">
      <div className="w-full flex flex-col gap-3">
        <div>
          <Link to={`/tintuc-chitiet/${newItem.slug}`}>
            <img
              src={firstImage}
              className="w-full h-auto object-cover rounded-[8px]"
            />
          </Link>
        </div>
        <div className="w-full px-[24px] py-[16px] flex flex-col gap-3">
          <div>
            <Link to={`/tintuc-chitiet/${newItem.slug}`}>
              <p>{newItem.title}</p>
            </Link>
          </div>
          <div className="flex items-center justify-between w-full">
            <div className="w-full flex items-center gap-1">
              <div className="w-[16px] h-[16px]">
                <img src={user_status} alt="u2" />
              </div>
              <p>{newItem.author}</p>
            </div>
            <div className="w-full flex items-center gap-1">
              <div className="w-[16px] h-[16px]">
                <img src={clock_3} alt="ck2" />
              </div>
              <p>{new Date(newItem.publishDate).toLocaleDateString()}</p>
            </div>
          </div>
          <div>
            <Divider />
          </div>

          <div className="w-full flex items-center gap-1">
            <div>
              <img src={list} alt="lio" />
            </div>
            <p>{getCategoryName(categories, newItem.categories)}</p>
          </div>

          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="h-32 overflow-auto overflow-x-hidden"
          />
        </div>
      </div>
    </div>
  );
}

export default function EventDetailBody({ relatedNews, categories }) {
  return (
    <div className="w-full bg-cada3">
      <div className="w-full container mx-auto px-[20px] py-[20px] flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <img src={sp} alt="sp3" />
          <p>TIN TỨC LIÊN QUAN</p>
        </div>
        <div>
          <div>
            <div className="w-full">
              <div className="block md:hidden">
                <Swiper
                  spaceBetween={10}
                  slidesPerView={1}
                  navigation={{
                    nextEl: ".next-btn",
                    prevEl: ".prev-btn",
                  }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  modules={[Navigation, Autoplay]}
                >
                  {relatedNews &&
                    relatedNews.map((newItem, index) => (
                      <SwiperSlide key={index}>
                        {renderMobileNewsItem(newItem, categories)}
                      </SwiperSlide>
                    ))}
                </Swiper>

                <div className="flex justify-center mt-4 gap-3">
                  <button className="prev-btn bg-white text-black rounded-full border-2 border-[#E2E2E2] border-solid flex items-center justify-center w-10 h-10">
                    <FaAngleLeft />
                  </button>
                  <button className="next-btn bg-white text-black rounded-full border-2 border-[#E2E2E2] border-solid flex items-center justify-center w-10 h-10">
                    <FaAngleRight />
                  </button>
                </div>
              </div>

              <div className="hidden md:block relative">
                <Swiper
                  spaceBetween={10}
                  slidesPerView={3}
                  navigation={{
                    nextEl: ".next-btn",
                    prevEl: ".prev-btn",
                  }}
                  autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  speed={5000}
                  modules={[Navigation, Autoplay]}
                >
                  {relatedNews.map((newItem, index) => (
                    <SwiperSlide key={index}>
                      {renderPCNewsItem(newItem, categories)}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
